import { useState } from "react";

import JSConfetti from "js-confetti";

const confetti = new JSConfetti();

export const useConfetti = () => {
  const [jsConfetti] = useState(confetti);

  return jsConfetti;
};
